"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.quizPerformanceUseAsPerformanceQuestion = quizPerformanceUseAsPerformanceQuestion;
var _immutable = require("immutable");
function quizPerformanceUseAsPerformanceQuestion(quiz, questionId) {
  if (quiz.get('status') === 'incomplete') return;
  var question = null;
  if (quiz.get('question_performance')) {
    var _quiz$get;
    var missingQuestion = (_quiz$get = quiz.get('question_performance')) === null || _quiz$get === void 0 ? void 0 : _quiz$get.find(function (q) {
      return q.question_id === questionId;
    });
    if (missingQuestion) {
      var missingSubjectIds = missingQuestion.subjects.map(function (sub) {
        return sub.id;
      });
      question = (0, _immutable.Map)({
        subjectIds: missingSubjectIds,
        potentialScore: missingQuestion.potential_score
      });
    }
  }
  return question;
}